import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star, Check, AlertTriangle } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42941923885127:1';
const URL_NEGOCIO = 'https://www.compradigitalya.com/cart/42941923983431:1';
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-24 px-4 max-w-6xl mx-auto scroll-mt-16" data-id="element-264">
      {/* COUNTDOWN BLOCK */}
      <div className="text-center mb-12 md:mb-16" data-id="element-265">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-266">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-2xl mx-auto text-slate-900" data-id="element-267">
          Asegurá el precio promocional{' '}
          <span className="text-primary" data-id="element-268">antes de que suba.</span>
        </h2>

        <div className="mb-6" data-id="element-269">
          <Countdown data-id="element-270" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-2xl mx-auto" data-id="element-271">
          <div className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-red-600 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-272">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-273" /> Después sube
            $9.000 ARS
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-red-600 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-274">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-275" /> Esta promo
            no vuelve
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-red-600 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-276">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-277" /> 🔴 72% de
            los cupos ya tomados
          </div>
        </div>
      </div>

      {/* OFFER */}
      <div className="text-center mb-10 md:mb-12" data-id="element-278">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-3 leading-tight text-slate-900" data-id="element-279">
          Elegí tu <span className="text-primary" data-id="element-280">opción</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-281">
        {/* OPTION 1 — COMBO COMPLETO */}
        <div className="bg-white border border-slate-200 shadow-sm rounded-3xl p-6 md:p-8 flex flex-col" data-id="element-282">
          <div className="mb-5" data-id="element-283">
            <div className="flex items-center gap-2 mb-2" data-id="element-284">
              <span className="text-3xl md:text-4xl" data-id="element-285">📘</span>
              <h3 className="text-xl md:text-2xl font-extrabold text-slate-900" data-id="element-286">
                Sistema Entrenamiento Prenatal Pro
              </h3>
            </div>
            <p className="text-slate-500 text-sm font-medium" data-id="element-287">
              5 Tomos + 5 Bonos
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 p-4 rounded-xl mb-6 text-sm text-slate-600 leading-relaxed" data-id="element-288">
            <span className="font-bold text-slate-900" data-id="element-289">Ideal para:</span>{' '}
            Profesionales que quieren tener todo el embarazo resuelto de manera
            segura.
          </div>

          <ul className="space-y-2 mb-6" data-id="element-290">
            {['5 Tomos PDF (Semana 1 a 40)', '5 Bonos estratégicos', 'Acceso inmediato (5 min)', 'Garantía 7 días'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-291">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-292" />
                <span className="text-slate-700 font-medium" data-id="element-293">{f}</span>
              </li>)}
          </ul>

          <div className="mb-6 flex-grow" data-id="element-294">
            <div className="text-slate-400 line-through text-base font-bold mb-1" data-id="element-295">
              Antes: $60.000
            </div>
            <div className="text-xs text-slate-500 mb-1 uppercase tracking-wide font-bold" data-id="element-296">
              Hoy
            </div>
            <div className="text-4xl md:text-5xl font-extrabold text-slate-900" data-id="element-297">
              $19.990
            </div>
          </div>

          <Button href={URL_COMBO} fullWidth className="py-4 text-base md:text-lg" data-id="element-298">
            👉 QUIERO MI SISTEMA AHORA
          </Button>
        </div>

        {/* OPTION 2 — COMBO + PRO (RECOMMENDED — HIGHLIGHTED) */}
        <div className="relative bg-gradient-to-b from-secondary to-purple-800 rounded-3xl p-6 md:p-8 flex flex-col shadow-[0_25px_70px_rgba(124,58,237,0.4)] ring-4 ring-secondary/30 transform md:-translate-y-4 md:scale-[1.03]" data-id="element-299">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-slate-900 font-extrabold px-5 py-1.5 rounded-full text-xs md:text-sm flex items-center gap-1.5 whitespace-nowrap shadow-[0_8px_20px_rgba(250,204,21,0.5)] animate-pulse" data-id="element-300">
            <Star className="w-4 h-4 fill-slate-900" data-id="element-301" /> ⭐ MÁS ELEGIDO
          </div>

          <div className="mb-5 mt-2" data-id="element-302">
            <div className="flex items-center gap-2 mb-2" data-id="element-303">
              <span className="text-3xl md:text-4xl" data-id="element-304">🏆</span>
              <h3 className="text-xl md:text-2xl font-extrabold text-white" data-id="element-305">
                Sistema Completo + Recuperación Postparto
              </h3>
            </div>
            <p className="text-purple-100 text-sm font-bold" data-id="element-306">
              5 Tomos + 5 Bonos + 50 páginas de Postparto
            </p>
          </div>

          <div className="bg-white/10 border border-white/20 backdrop-blur-sm p-4 rounded-xl mb-6 text-sm text-purple-50 leading-relaxed" data-id="element-307">
            <span className="font-bold text-white" data-id="element-308">Ideal para:</span>{' '}
            Profesionales que quieren acompañar a la alumna después del parto y
            asegurar 15-18 meses de ingresos.
          </div>

          <ul className="space-y-2 mb-6" data-id="element-309">
            {['TODO el Sistema Prenatal', '4 Fases de recuperación postparto', '48 ejercicios + 12 movilidades', 'Protocolo para cesárea, diástasis e incontinencia', '1 alumna = 15-18 meses de ingresos'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-310">
                <Check className="w-4 h-4 text-yellow-300 shrink-0 mt-0.5" data-id="element-311" />
                <span className="text-white font-bold" data-id="element-312">{f}</span>
              </li>)}
          </ul>

          <div className="mb-6 flex-grow" data-id="element-313">
            <div className="inline-flex items-center gap-1.5 bg-yellow-400 text-slate-900 font-extrabold text-xs px-3 py-1 rounded-full mb-3" data-id="element-314">
              🔥 AHORRÁS $47.000
            </div>
            <div className="text-purple-200 line-through text-base font-bold mb-1" data-id="element-315">
              Antes: $75.000
            </div>
            <div className="text-xs text-purple-100 mb-1 uppercase tracking-wide font-bold" data-id="element-316">
              Hoy
            </div>
            <div className="text-5xl md:text-6xl font-extrabold text-white" data-id="element-317">
              $27.990
            </div>
          </div>

          <Button href={URL_NEGOCIO} fullWidth className="py-5 text-base md:text-xl bg-yellow-400 text-slate-900 hover:bg-yellow-300 shadow-[0_8px_25px_rgba(250,204,21,0.5)] hover:shadow-[0_12px_35px_rgba(250,204,21,0.6)]" data-id="element-318">
            👉 QUIERO EL SISTEMA COMPLETO + POSTPARTO
          </Button>
        </div>
      </div>

      <p className="text-center text-xs md:text-sm text-slate-500 mt-8 font-medium" data-id="element-319">
        🔒 Pago 100% seguro · ⚡ Acceso en 5 minutos · 💳 Mercado Pago hasta 12
        cuotas
      </p>
    </section>;
}